<script lang="ts">
export default {
    name: "MiddleMonitor",
};
</script>
<script setup lang="ts">
import { store } from "@/store"
import JessibucaPlayer from '@/components/jessibuca-player/index.vue'
import OperationConsole from "./operationConsole.vue"
import AirportControl from "./airportControl.vue"
import eventPop from "./components/eventPop.vue"
import { getDeviceTopo1, getLiveCapacityBySn, startLivestream, GetDetectStreamAddr } from "@/api/monitorApi/index"
import { CameraMode } from '@/types/live-stream'
import { DeviceTypeName } from '@/types/enum'
import { onBeforeUnmount, onMounted, watch } from "vue";
import { emitter } from '@/utils/events'
import { changeLivestreamLens } from "@/api/monitorApi/drc";
import { usePayloadControl } from './use-payload-control';
import { ControlSource } from "@/types/enum";
import { DeviceOsdCamera } from '@/types/device';
import { EModeCode, EDockModeCode, EGear } from '@/types/device'
import JSWebrtc from "@/vendors/jswebrtc.min.js"
import { useConnectMqtt } from './use-connect-mqtt'
import { error } from "console"
import { useRoute } from 'vue-router';
import { ElLoading } from 'element-plus'

const route = useRoute();
const { checkPayloadAuth, changeCameraFocalLength, switchCameraAim, switchCameraMode, takeCameraPhoto, startCameraRecording, stopCameraRecording, } = usePayloadControl()

const routeList: any = ref([])
const airportList: any = ref([])
const videoUrl1 = ref()
const videoUrl2 = ref()
const videoUrl3 = ref()
const videoUrl4 = ref()
const title1 = ref()
const title2 = ref()
const title3 = ref()
const title4 = ref()

const videoUrl5 = ref()

const airportUrl = ref()
const uavUrl = ref()
const identifyUrl = ref()
const title5 = ref()

const livestreamSource = ref()
const droneList: any = ref([])
const livetypeSelected = ref(1)
const cameraSelectedId = ref()
const videoId = ref()
const videoList: any = ref([])
const osdVisible = computed(() => store.other.useMyStore().getOsdVisible)

const airList = ref([
    {
        name: "机库",
        value: 1
    }, {
        name: "无人机",
        value: 2
    }
])

const videoStatus = ref([
    {
        name: "原始视频",
        value: 1
    }, {
        name: "识别视频",
        value: 2
    }
])

const vidoeValue = ref(1)

// 负载控制
const payloadSelectInfo = {
    value: null as any,
    controlSource: undefined as undefined | ControlSource,
    options: [] as any,
    payloadIndex: '' as string,
    camera: undefined as undefined | DeviceOsdCamera // 当前负载osd信息
}
const recordingValue = ref(false)
const deviceState = computed(() => JSON.parse(JSON.stringify(store.other.useMyStore().deviceState)))
const str = '--'
const deviceInfo: any = reactive({
    gateway: {
        capacity_percent: str,
        transmission_signal_quality: str,
    },
    dock: {

    },
    device: {
        gear: -1,
        mode_code: EModeCode.Disconnected,
        height: str,
        home_distance: str,
        horizontal_speed: 0,
        vertical_speed: 0,
        wind_speed: str,
        wind_direction: str,
        elevation: str,
        position_state: {
            gps_number: str,
            is_fixed: 0,
            rtk_number: str
        },
        payload: [{
            gimbal_yaw: 0
        }],
        attitude_head: 0,
        battery: {
            capacity_percent: str,
            landing_power: str,
            remain_flight_time: 0,
            return_home_power: str,
        },
        latitude: str,
        longitude: str,
    }
})


const airValue = ref(2)
const domain = ref(3)
const cameraList = ref()
const handelDeviceType = async (type: number) => {
    console.log(store.informationListStore.informationStore().uavObj)
    // if (type === airValue.value) {
    //     return
    // }
    if (type === 2) {
        await getLiveCapacity(airNumber.value)
        if (droneList.value.length < 2) {
            ElMessage.warning('当前无人机不在线，无法查看直播')
            return
        }
        var uavObj = droneList.value.find((item: any) => item.domain == 0);
        console.log(uavObj)
        domain.value = uavObj.domain
        videoId.value = uavObj.value + '/' + uavObj.more[0].index + '/' + uavObj.more[0].videosList[0].index
        store.informationListStore.informationStore().setVideoId(videoId.value)
        const temp: any = []
        uavObj.more.forEach((ele: any) => {
            temp.push({ label: ele.name, value: ele.index, more: ele.videosList, id: ele.id })
        })
        cameraList.value = temp
        let lensList
        if (cameraList.value[1]) {
            lensList = cameraList.value[1]
        } else {
            lensList = cameraList.value[0]
        }
        if (lensList) {
            isNotFpv.value = lensList.label != 'FPV'
        }
        if (!uavUrl.value) {
            console.log(789)
            await uavStart()
        } else {
            initVideo(uavUrl.value)
        }
    } else {
        var airportObj = droneList.value.find((item: any) => item.domain == 3);
        domain.value = airportObj.domain
        videoId.value = airportObj.value + '/' + airportObj.more[0].index + '/' + airportObj.more[0].videosList[0].index
        const temp: any = []
        airportObj.more.forEach((ele: any) => {
            temp.push({ label: ele.name, value: ele.index, more: ele.videosList, id: ele.id })
        })
        cameraList.value = temp
        isNotFpv.value = cameraList.value[0].label !== 'FPV'
        if (!airportUrl.value) {
            await airportStart()
        } else {
            initVideo(airportUrl.value)
        }
    }
    airValue.value = type
    store.informationListStore.informationStore().setAirValueActive(airValue.value)
}

const getLiveCapacity = async (key: any) => {
    await getLiveCapacityBySn(key)
        .then(res => {

            console.log('刷新后值改变')
            if (!res.list.length) {
                console.warn('警告：获取直播容量为空!!!')
                return
            }
            const resData: Array<[]> = res.list
            livestreamSource.value = resData

            const temp: any = []
            if (livestreamSource.value) {
                livestreamSource.value.forEach((ele: any) => {
                    temp.push({ label: ele.name + '-' + ele.sn, value: ele.sn, more: ele.camerasList, domain: ele.domain })
                })
                droneList.value = temp
            }
            console.log(droneList.value)
        })
}

//切换机场
const airportStart = async () => {
    console.log(droneList.value)
    if (UAVPlayer.value) {
        UAVPlayer.value.destroy()
        UAVPlayer.value = null
    }
    var airportObj = droneList.value.find((item: any) => item.domain == 3);
    domain.value = airportObj.domain
    videoId.value = airportObj.value + '/' + airportObj.more[0].index + '/' + airportObj.more[0].videosList[0].index
    showVideoLoading()
    await startLivestream({
        url: import.meta.env.VITE_APP_RTMP_URL + airportObj.more[0].id,
        videoId: airportObj.value + '/' + airportObj.more[0].index + '/' + airportObj.more[0].videosList[0].index,
        urlType: livetypeSelected.value,
        videoQuality: 0
    })
        .then(res => {
            let url = res.url
            videoUrl5.value = url
            airportUrl.value = url
            initVideo(res.url)
        })
        .catch(err => {
            console.error(err)
            hideVideoLoading()
        })
}

// 切换无人机
const uavStart = async () => {
    if (droneList.value.length > 1 || droneList.value[0].domain == 0) {
        if (UAVPlayer.value) {
            UAVPlayer.value.destroy()
            UAVPlayer.value = null
        }
        var uavObj = droneList.value.find((item: any) => item.domain == 0);
        domain.value = uavObj.domain
        console.log('值改变')
        //无人机默认取下标1的镜头
        let lensList
        if (uavObj.more[1] && uavObj.more[1].index?.substring(0, 2) != "39") {
            lensList = uavObj.more[1]
        } else {
            lensList = uavObj.more[0]
        }
        payloadSelectInfo.payloadIndex = lensList.index
        store.informationListStore.informationStore().setPayloadIndex(lensList.index)
        store.informationListStore.informationStore().setVideoId(uavObj.value + '/' + lensList.index + '/' + lensList.videosList[0].index)
        showVideoLoading()
        await startLivestream({
            url: import.meta.env.VITE_APP_RTMP_URL + lensList.id,
            videoId: uavObj.value + '/' + lensList.index + '/' + lensList.videosList[0].index,
            urlType: livetypeSelected.value,
            videoQuality: 0
        })
            .then(res => {
                let url = res.url
                // store.informationListStore.informationStore().setVideoUrl(res.url);
                if (route.query.domain == "2") {
                    store.informationListStore.informationStore().setVideoUrl(res.url);
                }
                videoUrl5.value = url
                uavUrl.value = url
                initVideo(res.url)
            })
            .catch(err => {
                console.error(err)
                hideVideoLoading()
            })
        setTimeout(async () => {
            let url
            //获取识别视频流接口
            if(uavUrl.value){
                url = uavUrl.value.replace("webrtc", "rtmp");
            }else{
                return
            }
            let modelType
            if(uavObj.value == "1581F7FVC251500CY3PT" || uavObj.value == "1581F9F4X25C600A02PM"){
                modelType = 4
            }else{
                modelType = Number(import.meta.env.VITE_MODEL_TYPE)
            }
            const jobId:any = sessionStorage.getItem("jobId")
            await GetDetectStreamAddr({ inputUrl: url, outputType: 'webrtc', deviceSn: uavObj.value, modelType: modelType, taskId: jobId }, 2).then(resp => {
                let str = resp.url.slice(0, 24)
                str = str.replace("webrtc", "http");
                let str2 = resp.url.slice(24, resp.url.length)
                let url = str + import.meta.env.VITE_APP_BASE_PORT + str2 + ".flv"
                identifyUrl.value = resp.url

                // store.informationListStore.informationStore().setIdentifyType(2)
            }).catch((error) => {
                // store.informationListStore.informationStore().setIdentifyType(1)
            })
        }, 3000)
    }
}

const isNotFpv = ref(false)


// const changeIdentify = async () => {
//     if (identifyType.value == 2) {
//         await ondistinguishSelect(videoUrl5.value)

//     } else {
//         await uavStart()
//         identifyType.value = 1
//     }
// }

watch(() => store.informationListStore.informationStore().identifyType, async (data) => {
    console.log(data)
    if (data == 2) {
        await ondistinguishSelect(videoUrl5.value)
        vidoeValue.value = 2
    } else {
        initVideo(uavUrl.value)
        store.informationListStore.informationStore().setIdentifyType(1)
        vidoeValue.value = 1
    }
}, {
    // immediate: true,
    deep: true
})

const handelRecognize = (val: number) => {
    store.informationListStore.informationStore().setIdentifyType(val)
}

const uavModeCode = ref(0)

const onRefresh = async (key: any, index: any, type?: any) => {
    await getLiveCapacityBySn(key).then(res => {
        console.log('刷新后值改变')
        console.log(res)
        if (!res.list.length) {
            console.warn('警告：获取直播容量为空!!!')
            return
        }
        if (index == 0) {
            title1.value = res.list[0].name
        } else if (index == 1) {
            title2.value = res.list[0].name
        } else if (index == 2) {
            title3.value = res.list[0].name
        } else if (index == 3) {
            title4.value = res.list[0].name
        } else if (index == 4) {
            // title5.value = res[0].name
        }
        const resData: Array<[]> = res.list
        livestreamSource.value = resData

        const temp: any = []
        videoList.value = []
        if (livestreamSource.value) {
            livestreamSource.value.forEach((ele: any) => {
                temp.push({ label: ele.name + '-' + ele.sn, value: ele.sn, more: ele.camerasList, domain: ele.domain })
            })
            droneList.value = temp
            videoList.value.push(temp)
        }
        // if(droneList.value.length > 1){
        //   cameraSelectedId.value = droneList.value[1].more[1].id
        //   videoId.value = droneList.value[1].value + '/' + droneList.value[1].more[1].index + '/' + droneList.value[1].more[1].videosList[0].index
        // }else{
        //   cameraSelectedId.value = droneList.value[0].more[0].id
        //   videoId.value = droneList.value[0].value + '/' + droneList.value[0].more[0].index + '/' + droneList.value[0].more[0].videosList[0].index
        // }
    })
    if (route.query.domain != "2") {
        console.log(droneList.value, uavModeCode.value)
        await onStart(key, index)
        // if (droneList.value.length == 2) {
        //     if(uavModeCode.value == 0){
        //         await onStart(key, index)
        //     }else{
        //         console.log(123)
        //         await uavStart()
        //     }
        //     // store.informationListStore.informationStore().setAirValueActive(2)
        // } else if (droneList.value.length == 1 && droneList.value[0].domain == 3) {
        //     await onStart(key, index)
        // }
    } else {
        await uavStart()
    }
    // await uavStart()
}

const uavStatus = ref(null)
const onStart = async (deviceSn: any, number?: number) => {
    console.log('值改变')
    let liveURL = ''
    uavStatus.value = null
    //当有无人机的时候判断无人机是否为起飞状态如果是就切换到无人机画面 如果不是就切换到机场画面
    // if (droneList.value.length > 1) {
    //     let lensList
    //     var uavObj = droneList.value.find((item: any) => item.domain == 0);
    //     domain.value = uavObj.domain
    //     if (routeList.value.length) {
    //         uavStatus.value = routeList.value.find((item: any) => item.key == uavObj.value).mode_code;
    //     }
    //     if (uavObj && uavStatus.value != 0) {
    //         if (uavObj.more[1]) {
    //             lensList = uavObj.more[1]
    //         } else {
    //             lensList = uavObj.more[0]
    //         }
    //         cameraSelectedId.value = lensList.id
    //         videoId.value = uavObj.value + '/' + lensList.index + '/' + lensList.videosList[0].index
    //         airValue.value = 2
    //         store.informationListStore.informationStore().setAirValueActive(airValue.value)
    //     } else {
    //         var airportObj = droneList.value.find((item: any) => item.domain == 3);
    //         domain.value = airportObj.domain
    //         cameraSelectedId.value = airportObj.more[0].id
    //         videoId.value = airportObj.value + '/' + airportObj.more[0].index + '/' + airportObj.more[0].videosList[0].index
    //         airValue.value = 1
    //         store.informationListStore.informationStore().setAirValueActive(airValue.value)
    //     }

    // } else {
    //     var airportObj = droneList.value.find((item: any) => item.domain == 3);
    //     domain.value = airportObj.domain
    //     cameraSelectedId.value = airportObj.more[0].id
    //     videoId.value = airportObj.value + '/' + airportObj.more[0].index + '/' + airportObj.more[0].videosList[0].index
    //     airValue.value = 1
    //     store.informationListStore.informationStore().setAirValueActive(airValue.value)
    // }

    var airportObj = droneList.value.find((item: any) => item.domain == 3);
    console.log(airportObj)
    if (!airportObj) return
    domain.value = airportObj.domain
    cameraSelectedId.value = airportObj.more[0].id
    videoId.value = airportObj.value + '/' + airportObj.more[0].index + '/' + airportObj.more[0].videosList[0].index
    // airValue.value = 1
    // store.informationListStore.informationStore().setAirValueActive(airValue.value)

    // if (number == 4) {
    //     let list = []
    //     if (droneList.value.length > 1 && deviceInfo1.value && deviceInfo1.value[osdVisible.value.sn]?.mode_code !== 0) {
    //         var uavObj = droneList.value.find((item: any) => item.domain == 0);
    //         domain.value = uavObj.domain
    //         list = uavObj
    //         //无人机默认取下标1的镜头
    //         let lensList
    //         if (uavObj.more[1]) {
    //             lensList = uavObj.more[1]
    //         } else {
    //             lensList = uavObj.more[0]
    //         }
    //         console.log(lensList)
    //         payloadSelectInfo.payloadIndex = lensList.index
    //     } else if (droneList.value.length == 1 || deviceInfo1.value && deviceInfo1.value[osdVisible.value.sn]?.mode_code == 0) {
    //         var airportObj = droneList.value.find((item: any) => item.domain == 3);
    //         list = airportObj
    //     } else {
    //         console.log('没有选择无人机');
    //     }
    //     if (list.more) {
    //         const result: any = []
    //         list.more.forEach((ele: any) => {
    //             result.push({ label: ele.name, value: ele.index, more: ele.videosList, id: ele.id })
    //         })
    //         cameraList.value = result
    //         if (cameraList.value.length > 1) {
    //             isNotFpv.value = cameraList.value[1].label !== 'FPV'
    //         } else {
    //             isNotFpv.value = cameraList.value[0].label !== 'FPV'
    //         }
    //     }
    // }
    liveURL = import.meta.env.VITE_APP_RTMP_URL + cameraSelectedId.value
    await startLivestream({
        url: liveURL,
        videoId: videoId.value,
        urlType: livetypeSelected.value,
        videoQuality: 0
    })
        .then(res => {
            console.log(res)
            let url = res.url
            store.informationListStore.informationStore().setVideoUrl(res.url);
            // if (number == 0) {
            //     videoUrl1.value = res.url
            //     initVideo(res.url, deviceSn)
            // } else if (number == 1) {
            //     videoUrl2.value = res.url
            //     initVideo(res.url, deviceSn)
            // } else if (number == 2) {
            //     videoUrl3.value = res.url
            //     initVideo(res.url, deviceSn)
            // } else if (number == 3) {
            //     videoUrl4.value = res.url
            //     initVideo(res.url, deviceSn)
            // } else if (number == 4) {
            //     videoUrl5.value = res.url
            //     initVideo(res.url)
            //     //当有无人机的时候判断无人机是否为起飞状态如果是就切换到智能识别
            //     // if (droneList.value.length > 1 && uavStatus.value && uavStatus.value !=0) {
            //     //     ondistinguishSelect(res.url)
            //     // } else {
            //     //     videoUrl5.value = url
            //     //     initVideo(res.url)
            //     // }
            // }
        })
        .catch(err => {
            console.error(err)
        })
}

let player: any = null
const UAVPlayer = ref()
const videoLoading = ref(false)
let videoLoadingTimer: ReturnType<typeof setTimeout> | null = null

const showVideoLoading = () => {
    videoLoading.value = true
    if (videoLoadingTimer) clearTimeout(videoLoadingTimer)
    videoLoadingTimer = setTimeout(() => {
        videoLoading.value = false
        videoLoadingTimer = null
    }, 15000)
}

const hideVideoLoading = () => {
    videoLoading.value = false
    if (videoLoadingTimer) {
        clearTimeout(videoLoadingTimer)
        videoLoadingTimer = null
    }
}

const createWebrtcPlayer = (videoDom: HTMLVideoElement, playUrl: string) => {
    return new JSWebrtc.Player(playUrl, {
        video: videoDom,
        autoplay: true,
        onPlay: () => {
            videoDom.addEventListener('canplay', function onCanPlayOnce() {
                videoDom.play()
            }, { once: true })
            hideVideoLoading()
        }
    })
}

const getPlayableWebrtcUrl = (url: any) => {
    if (typeof url !== "string") return ""
    const trimUrl = url.trim()
    if (!trimUrl) return ""
    if (trimUrl.startsWith("webrtc://")) return trimUrl
    if (trimUrl.startsWith("http://")) return trimUrl.replace("http://", "webrtc://")
    if (trimUrl.startsWith("https://")) return trimUrl.replace("https://", "webrtc://")
    return ""
}

const initVideo = (url: any, visitNo?: any) => {
    const playUrl = getPlayableWebrtcUrl(url)
    if (!playUrl) {
        return
    }
    showVideoLoading()
    if (visitNo) {
        if (player) {
            player.destroy()
            player = null
        }
        setTimeout(() => {
            let videoDom: any = document.getElementById(visitNo)
            if (!videoDom) {
                hideVideoLoading()
                return
            }
            player = createWebrtcPlayer(videoDom, playUrl)
        }, 1000)
    } else {
        if (UAVPlayer.value) {
            UAVPlayer.value.destroy()
            UAVPlayer.value = null
        }
        setTimeout(() => {
            let videoDom: any = document.getElementById("webrtc")
            if (!videoDom) {
                hideVideoLoading()
                return
            }
            UAVPlayer.value = createWebrtcPlayer(videoDom, playUrl)
        }, 1000)
    }
}

const flight_id = ref()
function handleTaskWsEvent(payload: any) {
    const id = payload?.data?.output?.ext?.flight_id
    if (id) {
        flight_id.value = id
    }
    const infoStore = store.informationListStore.informationStore()
    if (infoStore.executionStatus) {
        infoStore.setExecutionStatus(false)
    }
}

//智能识别开启
const ondistinguishSelect = async (val: any,) => {
    if (identifyUrl.value) {
        initVideo(identifyUrl.value)
    } else {
        setTimeout(() => {
            initVideo(identifyUrl.value)
        }, 20000)
    }
}

const webrtc = ref()

const handleDoubleClick = () => {
    if (airValue.value == 1) {
        return
    }
    var airportObj = droneList.value.find((item: any) => item.domain == 3);
    let video
    video = webrtc.value
    if (!video) return;
    // 获取video的长宽
    const width = video.offsetWidth;
    const height = video.offsetHeight;

    // 获取双击时的位置
    const bounds = video.getBoundingClientRect();
    const x = event.clientX - bounds.left; // 相对于video左上角的x坐标
    const y = event.clientY - bounds.top;  // 相对于video左上角的y坐标

    const percentageX = Number(x) / width
    const percentageY = Number(y) / height
    console.log(parseFloat(percentageX.toFixed(4)), parseFloat(percentageY.toFixed(4)))

    console.log(`Video width: ${width}, height: ${height}`);
    console.log(`Double clicked at x: ${x}, y: ${y}`);

    return switchCameraAim(airportObj.value, {
        payload_index: payloadSelectInfo.payloadIndex,
        camera_type: "zoom",
        locked: false,
        x: parseFloat(percentageX.toFixed(4)),
        y: parseFloat(percentageY.toFixed(4)),
    })
}

const refreshBtn = () => {
    if (UAVPlayer.value) {
        UAVPlayer.value.destroy()
        UAVPlayer.value = null
        initVideo(uavUrl.value)
    }
}

const imageBase = ref()
const isEvent = ref(false)
const addEventBtn = () => {
    if (airValue.value == 2) {
        isEvent.value = true
        const canvas = document.createElement("canvas");
        const a = document.createElement("a");
        canvas.width = webrtc.value.clientWidth;
        canvas.height = webrtc.value.clientHeight;
        const ctx = canvas.getContext("2d");

        if (ctx && webrtc.value.videoWidth && webrtc.value.videoHeight) {
            ctx.drawImage(
                webrtc.value,
                0,
                0,
                canvas.width,
                canvas.height
            );
            imageBase.value = canvas.toDataURL('image/png');
        }
    }
}

provide('imageBase', imageBase);


watch(deviceState, (data, oldVal) => {
    // console.log(data, oldVal)
    if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[data.currentSn]) {
        if (Object.keys(data.deviceInfo).length) {
            routeList.value = Object.entries(data.deviceInfo).map(([key, value]) => ({
                key,
                ...value,
            }));
        } else {
            routeList.value = []
        }
        // console.log('设备状态:', routeList.value)
    }

    if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[store.informationListStore.informationStore().uavObj.childSn]) {
        //  console.log('设备状态:', data.deviceInfo)
        deviceInfo.device = data.deviceInfo[store.informationListStore.informationStore().uavObj.childSn]
    }
    if (route.query.domain != "2") {
        if (data.currentType === DeviceTypeName.Dock && data.dockInfo[store.informationListStore.informationStore().uavObj.gatewaySn]) {
            // console.log('机场状态:', data.dockInfo[searchValue.value.gatewaySn])
            // console.log(searchValue.value.gatewaySn)
            deviceInfo.dock = data.dockInfo[store.informationListStore.informationStore().uavObj.gatewaySn]
        }
    }
}, {
    immediate: true,
    deep: true
})

const status = ref()
const loading = ref()
const deviceInfo1 = computed(() => JSON.parse(JSON.stringify(store.other.useMyStore().deviceState.deviceInfo)))
watch(() => deviceInfo1.value, async (newVal, oldVal) => {
    //   console.log(newVal)
    // if(Object.keys(newVal).length){
    //   console.log(newVal[osdVisible.value.sn])
    // }
    // if(oldVal && Object.keys(oldVal).length){
    //   console.log(oldVal[osdVisible.value.sn])
    // }
    if(newVal[store.informationListStore.informationStore().uavObj.childSn]?.mode_code){
        uavModeCode.value = newVal[store.informationListStore.informationStore().uavObj.childSn]?.mode_code
    }else{
        uavModeCode.value = 0
    }
    if (Object.keys(newVal).length && oldVal && Object.keys(oldVal).length) {
        if (newVal[store.informationListStore.informationStore().uavObj.childSn]?.mode_code !== oldVal[store.informationListStore.informationStore().uavObj.childSn]?.mode_code) {
            if (newVal[store.informationListStore.informationStore().uavObj.childSn].mode_code == 0) {
                status.value = 0
            } else if (newVal[store.informationListStore.informationStore().uavObj.childSn].mode_code == 5 || newVal[store.informationListStore.informationStore().uavObj.childSn].mode_code == 4 || newVal[store.informationListStore.informationStore().uavObj.childSn].mode_code == 9 || newVal[store.informationListStore.informationStore().uavObj.childSn].mode_code == 3) {
                status.value = 1

            }
            //  else if (newVal[osdVisible.value.sn].mode_code == 10) {
            //     await airportStart()
            // }
        } else if (newVal[store.informationListStore.informationStore().uavObj.childSn]?.mode_code == 5 || newVal[store.informationListStore.informationStore().uavObj.childSn]?.mode_code == 9 || newVal[store.informationListStore.informationStore().uavObj.childSn]?.mode_code == 3) {
            status.value = 1
        }
    }
}, {
    deep: true,
    immediate: true
})


watch(status, async (newVal, oldVal) => {
    console.log(newVal, oldVal)
    if (newVal != oldVal) {
        if (newVal == 1) {
            store.informationListStore.informationStore().setTreatActive(true)
            loading.value?.close()
            loading.value = undefined
            console.log("状态改变为1")
            domain.value = 0
            if(!uavUrl.value){
                handelDeviceType(2)
                // onRefresh(store.informationListStore.informationStore().uavObj.childSn,4)
                // airValue.value = 2
            }else{
                initVideo(uavUrl.value)
            }
            store.informationListStore.informationStore().setAirValueActive(2)
        } else {
            console.log("状态改变为0")
            airValue.value = 1
            domain.value = 3
            store.informationListStore.informationStore().setTreatActive(false)
            // handelDeviceType(1)
            localStorage.removeItem("treatValue")
        }
    }
}, {
    deep: true,
})

watch(() => store.informationListStore.informationStore().executionStatus, (data: any) => {
    console.log(data)
    if (data) {
        loading.value?.close()
        loading.value = ElLoading.service({
            lock: true,
            text: '加载中...',
            customClass: "loadClass"
        })
    } else {
        loading.value?.close()
        loading.value = undefined
    }
}, {
    immediate: true,
    deep: true,
})

onBeforeUnmount(() => {
    loading.value?.close()
    loading.value = undefined
    hideVideoLoading()
})



const nowList: any = ref([])




const airNumber = ref()

watch(() => store.informationListStore.informationStore().airNumberValue, async (data, oldVal) => {
    console.log(data)
    airNumber.value = data
    if (airNumber.value) {
        console.log(456456)
        await onRefresh(airNumber.value, 4)
    } else {
        // console.log(456456)
        // nowList.value.forEach(async (item: any, index: any) => {
        //     // console.log(item)
        //     await onRefresh(item.deviceSn, index)
        // })
    }
}, {
    immediate: true,
    deep: true
})

watch(() => store.informationListStore.informationStore().treatActive, async (data, oldVal) => {
    console.log(data, airValue.value)
    if (data && airValue.value == 1) {
        console.log(888)
        // await onRefresh(airNumber.value, 4)
    } else if (data && airValue.value == 2) {
        // if(!uavUrl.value){
        //     console.log(456)
        //     await uavStart()
        // }else{
        //     initVideo(uavUrl.value)
        // }
    } else {
        console.log(UAVPlayer.value)
        if (UAVPlayer.value) {
            UAVPlayer.value.destroy()
            UAVPlayer.value = null
        }
    }
}, {
    deep: true
})

const organizationData: any = computed(() => store.informationListStore.informationStore().organizationData)
async function getOnlineTopo() {
    const params: any = {}
    params.page = 1
    params.size = 999
    params.provinceCode = import.meta.env.VITE_APP_AREACODE,
        params.cityCode = organizationData.value.cityCode,
        params.areaCode = organizationData.value.areaCode,
        params.orgId = organizationData.value.provinceCode,
        params.domain = [2, 3]
    await getDeviceTopo1(params).then((res) => {
        airportList.value = res.list.filter((item: any) => item.latitude !== null)
    })
}

const contractActive = ref(true)
const contractBtn = () => {
    contractActive.value = !contractActive.value
    store.informationListStore.informationStore().setContractActive(contractActive.value)
}

useConnectMqtt()

onMounted(() => {
    getOnlineTopo()
    if (route.query.domain == "2") {
        airValue.value = 2
        store.informationListStore.informationStore().setAirValueActive(airValue.value)
        store.informationListStore.informationStore().setTreatActive(false)
        onRefresh(route.query.deviceSn, 4)
    }
    emitter.on('flightTaskWs', handleTaskWsEvent)
})
</script>

<template>
    <div class="middl-mointor">
        <div class="middle-full-box" v-if="store.informationListStore.informationStore().treatActive">
            <div class="video-box">
                <div class="videoplayerFull">
                    <div class="control-box" :style="contractActive ? 'right:21vw' : 'right:1.3vw'">
                        <img class="shuaxin" src="@/assets/icons/shuaxin.png" alt="" @click="refreshBtn"></img>
                        <img class="photo" src="@/assets/icons/photo-icon.png" alt="" @click="addEventBtn">
                        <div class="shousuo" @click="contractBtn">
                            <img src="@/assets/icons/shou-pic.png" v-if="contractActive" alt="">
                            <img src="@/assets/icons/suo-pic.png" v-else alt="">
                        </div>
                    </div>
                    <div class="switch-box">
                        <div class="air-switch">
                            <div class="switch-list" v-for="(item, index) in videoStatus" :key="index"
                                @click="handelRecognize(item.value)">
                                <p :class="vidoeValue == item.value ? 'airActive' : ''">{{ item.name }}</p>
                                <!-- <p v-if="airValue == item.value"></p> -->
                            </div>
                        </div>
                    </div>
                    <video id="webrtc" ref="webrtc" :controls="false" muted style="width: 100%;height: 100%;"
                        @dblclick.prevent="handleDoubleClick"></video>
                    <div class="video-loading-mask" v-if="videoLoading">
                        <div class="video-loading-content">
                            <div class="video-loading-spinner"></div>
                            <span>视频拉流中...</span>
                        </div>
                    </div>
                </div>
                <OperationConsole :payloadIndex="payloadSelectInfo.payloadIndex" :deviceInfo="deviceInfo"
                    v-if="!domain" />
            </div>
        </div>
        <AirportControl v-if="domain" />

        <eventPop v-model:isEvent="isEvent" />
    </div>
</template>

<style>
.loadClass {
    position: absolute;
    left: 50%;
    top: 40%;
    font-size: 20px;
    background-color: transparent !important;
}
</style>
<style scoped lang="scss">
.middle-monitor {
    position: absolute;
    top: 3rem;
    left: 22.5vw;
    width: 55vw;
    height: 92.6vh;
    margin: 0 0;
    pointer-events: all;

    .video-box {
        width: 100%;
        height: 100vh;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .videoplayer {
            width: 27.2vw;
            height: 38vh;

            video::-webkit-media-controls-panel {
                display: none !important;
            }
        }

        .videoplayerFull {
            width: 53vw;
            height: 82vh;

            video::-webkit-media-controls-panel {
                display: none !important;
            }
        }
    }

    .pagination-box {
        .el-pagination {
            justify-content: center;
            background-color: transparent;

            :deep(.el-pager) {
                li {
                    background-color: transparent;
                    color: #fff;
                }

                .is-active {
                    color: var(--el-pagination-hover-color);
                }
            }

            :deep(button) {
                background-color: transparent;

                .el-icon {
                    color: #fff;
                }
            }
        }
    }
}

.middle-full-box {
    position: absolute;
    top: 0;
    left: 0vw;
    width: 100vw;
    height: 100vh;
    margin: 0 0;

    .small-title {
        margin-left: 25vw;
    }

    .video-box {
        width: 100%;
        height: 100vh;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .videoplayerFull {
            width: 100%;
            height: 100%;
            position: relative;

            .video-loading-mask {
                position: absolute;
                inset: 0;
                z-index: 2;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(3, 18, 30, 0.65);
                pointer-events: none;

                .video-loading-content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 0.75rem;
                    color: #19E0FF;
                    font-size: 1rem;
                    font-family: AlibabaPuHuiTi, sans-serif;
                }

                .video-loading-spinner {
                    width: 2.5rem;
                    height: 2.5rem;
                    border: 3px solid rgba(25, 224, 255, 0.2);
                    border-top-color: #19E0FF;
                    border-radius: 50%;
                    animation: video-loading-spin 0.8s linear infinite;
                }
            }

            @keyframes video-loading-spin {
                to {
                    transform: rotate(360deg);
                }
            }

            .control-box {
                position: absolute;
                right: 21vw;
                top: 7.7vh;
                z-index: 1;
                display: flex;
                align-items: center;

                .shuaxin {
                    width: 1.875rem;
                    height: 1.875rem;
                    cursor: pointer;
                }

                .photo {
                    width: 1.6vw;
                    height: 2.3vh;
                    cursor: pointer;
                }
            }

            .shousuo {
                width: 1.6vw;
                height: 2.8vh;
                margin-left: 0.4vw;
                cursor: pointer;
                z-index: 1;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .switch-box {
                position: absolute;
                top: 120px;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 1;
            }

            .air-switch {
                width: 9.9vw;
                height: 2.2vh;
                line-height: 2.2vh;
                display: flex;
                z-index: 1;
                color: #fff;
                justify-content: space-between;
                background: url("@/assets/images/switch-bg.png") center no-repeat;
                background-size: 100% 100%;

                .switch-list {
                    cursor: pointer;
                    width: 9.9vw;
                    height: 2.2vh;

                    p {
                        width: 5vw;
                        height: 2.2vh;
                        line-height: 2.2vh;
                        font-family: YouSheBiaoTiHei;
                        font-size: 1.125rem;
                        font-weight: normal;
                        color: #FFFFFF;
                        line-height: 2.2vh;
                        text-align: center;
                    }

                    .airActive {
                        color: #19E0FF !important;
                        background: url("@/assets/images/active-air.png") center no-repeat;
                        background-size: 100% 100%;
                        // text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.85) !important;
                    }
                }

            }

            .posAbRight {
                display: flex;
                width: 9.9vw;
                height: 2.2vh;
                background: rgba(3, 18, 30, 0.5);
                line-height: 2.2vh;
                justify-content: space-around;
                position: absolute;
                top: 35px;
                z-index: 1;

                p {
                    width: 3.3vw;
                    font-size: .875rem;
                    text-align: center;
                    color: #fff;
                    font-family: AlibabaPuHuiTi;
                    cursor: pointer;
                }

                .posActive {
                    width: 3.3vw;
                    background: rgba(25, 224, 255, 0.41);
                    box-sizing: border-box;
                    border: 1px solid #19E0FF;
                    font-family: AlibabaPuHuiTi;
                }
            }

            .identifyRight {
                display: flex;
                width: 9.9vw;
                height: 2.9vh;
                background: rgba(3, 18, 30, 0.5);
                line-height: 2.2vh;
                justify-content: space-around;
                z-index: 1;
                position: absolute;
                top: 65px;

                :deep(.el-form-item__label) {
                    font-size: .875rem;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 2.9vh;
                    padding: 0 2.3vw 0 0;
                }

                :deep(.el-form-item__content) {
                    // line-height: 2.7vh;
                    margin-top: .3vh;
                }

                .el-switch {
                    align-items: normal;

                    :deep(.el-switch__label) {
                        color: #E8EBEF;
                    }

                    .el-switch__core {
                        // background: linear-gradient(115deg, rgba(64, 255, 249, 0.83) 0%, #408CFF 100%);
                        border: none;
                    }
                }
            }

            .cameraRight {
                display: flex;
                width: 9.9vw;
                height: 2.2vh;
                background: rgba(3, 18, 30, 0.5);
                line-height: 2.2vh;
                justify-content: space-around;
                z-index: 1;
                position: absolute;
                top: 100px;

                p {
                    width: 4.8vw;
                    font-size: .875rem;
                    font-family: AlibabaPuHuiTi;
                    text-align: center;
                    color: #fff;
                    cursor: pointer;
                }

                .posActive {
                    width: 4.8vw;
                    background: rgba(25, 224, 255, 0.41);
                    font-family: AlibabaPuHuiTi;
                    box-sizing: border-box;
                    border: 1px solid #19E0FF;
                }
            }

            .sliderBox {
                position: absolute;
                left: -180px;
                top: 55px;
                z-index: 1;
            }

            video::-webkit-media-controls-panel {
                display: none !important;
            }
        }
    }

    .pagination-box {
        .el-pagination {
            justify-content: center;
            background-color: transparent;

            :deep(.el-pager) {
                li {
                    background-color: transparent;
                    color: #fff;
                }

                .is-active {
                    color: var(--el-pagination-hover-color);
                }
            }

            :deep(button) {
                background-color: transparent;

                .el-icon {
                    color: #fff;
                }
            }
        }
    }
}
</style>